import { IItemTagActions, ItemTagContext } from './actions.types';
import { ITagData } from '@/models';

export const actions: IItemTagActions = {
  fetchTags(context: ItemTagContext): Promise<void> {
    const promise = this.$services.itemTag.fetchTags();
    context.commit('SET_LAST_PROMISE', promise);
    return promise.then((tags: ITagData[]) => {
      if (promise == context.state.lastPromise) {
        context.commit('SET_ITEM_TAGS', tags);
        context.commit('SET_LAST_PROMISE', null);
      }
    });
  },

  fetchTag(context: ItemTagContext, payload: number): Promise<void> {
    return this.$services.itemTag.fetchTag(payload).then((tag: ITagData) => {
      const index = context.state.tags.findIndex(
        (v: ITagData) => v.id === tag.id
      );
      if (index === -1) {
        context.commit('ADD_ITEM_TAG', tag);
      } else {
        context.commit('UPDATE_ITEM_TAG', tag);
      }
    });
  },

  createTag(context: ItemTagContext, payload: ITagData): Promise<void> {
    return this.$services.itemTag
      .createTag(payload)
      .then((tag: ITagData) => context.commit('ADD_ITEM_TAG', tag));
  },

  updateTag(context: ItemTagContext, payload: ITagData): Promise<void> {
    return this.$services.itemTag.updateTag(payload).then((tag: ITagData) => {
      const index = context.state.tags.findIndex(
        (v: ITagData) => v.id === tag.id
      );
      if (index === -1) {
        context.commit('ADD_ITEM_TAG', tag);
      } else {
        context.commit('UPDATE_ITEM_TAG', tag);
      }
    });
  },

  deleteTag(context: ItemTagContext, payload: number): Promise<void> {
    return this.$services.itemTag.deleteTag(payload).then(() => {
      context.commit('REMOVE_ITEM_TAG', payload);
    });
  }
};
